import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Lesson create / edit modal. Scope kept minimal in the routed world:
 *   - title + is_optional + is_free + require_clips_watched
 *   - read-only display of recommended_order + link to the recommended screen
 * The passing-assessment UI is NOT here — it lives on the lesson page (the
 * hub). Same modal-state pattern (initialValues + Form key + destroyOnHidden).
 */
import React, { useState } from 'react';
import { Checkbox, Form, Input, Modal, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { createLesson, updateLesson } from '../../api';
import { notifySuccess } from '../errors';
export function LessonModal({ open, onClose, onDone, trackId, gradeId, initial }) {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const initialValues = initial
        ? {
            title: initial.title,
            is_optional: !!initial.is_optional,
            is_free: !!initial.is_free,
            require_clips_watched: !!initial.require_clips_watched,
        }
        : { is_optional: false, is_free: false, require_clips_watched: false };
    const formKey = initial ? `edit-${initial.id}` : 'create';
    const submit = async () => {
        let v;
        try {
            v = await form.validateFields();
        }
        catch {
            return;
        }
        setSubmitting(true);
        try {
            // recommended_order intentionally omitted — owned by the recommended
            // path tab on the grade page, not by a per-lesson form.
            const payload = {
                title: v.title.trim(),
                is_optional: !!v.is_optional,
                is_free: !!v.is_free,
                require_clips_watched: !!v.require_clips_watched,
            };
            if (initial) {
                await updateLesson(initial.id, payload);
                notifySuccess('שיעור עודכן');
            }
            else {
                await createLesson({ ...payload, track_id: trackId });
                notifySuccess('שיעור נוצר');
            }
            onDone();
        }
        catch { /* client auto-surfaces */ }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsx(Modal, { title: initial ? 'עריכת שיעור' : 'יצירת שיעור', open: open, onCancel: onClose, onOk: submit, okText: "\u05E9\u05DE\u05D5\u05E8", cancelText: "\u05D1\u05D8\u05DC", confirmLoading: submitting, destroyOnHidden: true, children: _jsxs(Form, { form: form, layout: "vertical", preserve: false, initialValues: initialValues, children: [_jsx(Form.Item, { name: "title", label: "\u05DB\u05D5\u05EA\u05E8\u05EA", rules: [{ required: true, message: 'כותרת נדרשת' }], children: _jsx(Input, {}) }), initial && (_jsx(Form.Item, { label: "\u05E1\u05D3\u05E8 \u05D1\u05DE\u05E1\u05DC\u05D5\u05DC \u05D4\u05DC\u05D9\u05DE\u05D5\u05D3 \u05D4\u05DE\u05D5\u05DE\u05DC\u05E5", children: _jsxs(Space, { children: [_jsx(Typography.Text, { children: initial.recommended_order !== null && initial.recommended_order !== undefined
                                    ? initial.recommended_order
                                    : 'מחוץ למסלול' }), _jsx(Link, { to: `/grades/${gradeId}/recommended`, onClick: onClose, children: "\u05E0\u05D4\u05DC \u05D1\u05D8\u05D0\u05D1 \u05D4\u05DE\u05E1\u05DC\u05D5\u05DC \u05D4\u05DE\u05D5\u05DE\u05DC\u05E5" })] }) })), _jsx(Form.Item, { name: "is_optional", valuePropName: "checked", children: _jsx(Checkbox, { children: "\u05E8\u05E9\u05D5\u05EA" }) }), _jsx(Form.Item, { name: "is_free", valuePropName: "checked", children: _jsx(Checkbox, { children: "\u05D7\u05D9\u05E0\u05DD" }) }), _jsx(Form.Item, { name: "require_clips_watched", valuePropName: "checked", children: _jsx(Checkbox, { children: "\u05D7\u05D5\u05D1\u05D4 \u05DC\u05E6\u05E4\u05D5\u05EA \u05D1\u05DB\u05DC \u05D4\u05E7\u05DC\u05D9\u05E4\u05D9\u05DD" }) })] }, formKey) }));
}
